import {React,useReducer,useEffect,useState} from 'react'
import { Moviename } from '../Component/Fetcher';
import { useNavigate } from 'react-router-dom';

const initaistate ={
  data :[],
  error:'',
  loading :true
}


const reducer=(state,action)=>{
switch(action.type){
  case 'success':
    return{
      ...state,
      data :action.payload,
      loading: false
    }
    case 'failed':
      return{
        ...state,
        data :[],
        error : action.errormessage,
        loading :false
      }
}
}









const Header = () => {


const navigate =useNavigate()

  const[productdata,dispatch]= useReducer(reducer,initaistate)
  const[showmenu, setshowmenu]= useState(true)

  useEffect(()=>{
    Moviename({dispatch})
  },[])


const render=()=>{
return productdata.data.map(data=>(
<li id='list' onClick={()=>navigate(`/Categoriemovie/${data.id}`)} key={data.id}>{data.title}</li>
))



}

const click=()=>{
  setshowmenu(prevState=>!prevState)
}

const showvalue = showmenu ?'hide':'show'
  return (
    <div>
    <div id='Header-wrapper'>
        <div id='logo-container'>        
          <img onClick={()=>navigate('/')} src='/asset/logo.png'/>
      
        </div>


        <div id='drop-down-container'>
        <img onClick={()=>click()} style={{color:'white'}} src={'/asset/menu.png'}/>

        
        </div>
        
    </div>
    <div className={showvalue} id='menu-sm'>
    {productdata.loading ?'loading':render()}
    {productdata.error ?productdata.error:''}
    
    </div>
   
    </div>
  )
}

export default Header